<template>
  <v-menu
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on" :loading="loading">
        <v-icon color="primary">mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <slot name="default"></slot>
  </v-menu>
</template>

<script>
export default {
  name: 'ContextMenuIcon',
  props: {
    title: {
      default () {
        return null;
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
